import { render } from "./NewCommentMessage.vue.js?vue&type=template&id=1db3e5aa&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./NewCommentMessage.vue?vue&type=template&id=1db3e5aa&scoped=true"
import script from "./NewCommentMessage.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./NewCommentMessage.vue?vue&type=script&lang=js"
export * from "./NewCommentMessage.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./NewCommentMessage.vue?vue&type=script&lang=js"

import "./NewCommentMessage.vue.scss?vue&type=style&index=0&id=1db3e5aa&scoped=true&lang=scss!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./NewCommentMessage.vue?vue&type=style&index=0&id=1db3e5aa&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1db3e5aa"],['__file',"src/SharedWeb/scripts/components/community/chatrooms/comments/NewCommentMessage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1db3e5aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1db3e5aa', __exports__)) {
    api.reload('1db3e5aa', __exports__)
  }
  
  module.hot.accept("./NewCommentMessage.vue.js?vue&type=template&id=1db3e5aa&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./NewCommentMessage.vue?vue&type=template&id=1db3e5aa&scoped=true", () => {
    api.rerender('1db3e5aa', render)
  })

}


export default __exports__